/**
 * Full-page navigation helper.
 *
 * Exists primarily as a test seam: jsdom 26 made `window.location` and all of
 * its members [LegacyUnforgeable], so tests can no longer spy on
 * `window.location.assign` or redefine `window.location.href`. Code that
 * needs its navigation asserted in tests should call `navigateTo` and tests
 * should `jest.mock('~publish/helpers/navigation')`.
 *
 * `location.assign(url)` and `location.href = url` are spec-equivalent; this
 * helper standardizes on `assign`.
 */
export function navigateTo(url: string): void {
  window.location.assign(url)
}
